/**
 * @generated SignedSource<<dd5568f9796a9ebef2bcfac4e7d87f7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteMultipleSkillsInput = {
  ids?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteMultipleSkillsMutation$variables = {
  input: DeleteMultipleSkillsInput;
};
export type deleteMultipleSkillsMutation$data = {
  readonly deleteMultipleSkills: {
    readonly deletedSkillIds: ReadonlyArray<string | null> | null;
  } | null;
};
export type deleteMultipleSkillsMutation = {
  variables: deleteMultipleSkillsMutation$variables;
  response: deleteMultipleSkillsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMultipleSkillsPayload",
    "kind": "LinkedField",
    "name": "deleteMultipleSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSkillIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteMultipleSkillsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteMultipleSkillsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f86410e3d65c01cc6054398dc486afb4",
    "id": null,
    "metadata": {},
    "name": "deleteMultipleSkillsMutation",
    "operationKind": "mutation",
    "text": "mutation deleteMultipleSkillsMutation(\n  $input: DeleteMultipleSkillsInput!\n) {\n  deleteMultipleSkills(input: $input) {\n    deletedSkillIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "52f90120611f906e913f49716969e21a";

export default node;
